import { render, staticRenderFns } from "./ContentTemplateDeleteModal.vue?vue&type=template&id=46771f64&"
import script from "./ContentTemplateDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./ContentTemplateDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports